import React, { useEffect, useState, useContext } from "react";
import RegisterForm from "./RegisterForm"; 
import { AuthContext } from '../AuthContext';
import { Link } from "react-router-dom";
import DownloadReport from './DownloadReport';

const AdminPanel = () => {
  const [users, setUsers] = useState([]); // Список пользователей
  const [newPassword, setNewPassword] = useState(""); // Новый пароль
  const [selectedUser, setSelectedUser] = useState(null); // ID пользователя
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const {role} = useContext(AuthContext); 
  

  // Загружаем пользователей
const fetchUsers = async () => {
    try {
      const res = await fetch("/api/users");
      const data = await res.json();
      setUsers(data);
    } catch (err) {
      setError("Ошибка загрузки пользователей");
    }
  };
  
  // Загружаем при монтировании
  useEffect(() => {
    fetchUsers();
  }, []);

  // Функция смены пароля
  const handleChangePassword = async () => {
    if (!selectedUser || newPassword.length < 6) {
      setError("Выберите пользователя и введите пароль (мин. 6 символов)");
      return;
    }

    try {
      const response = await fetch(`/api/change-password/${selectedUser}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ newPassword }),
      });

      const data = await response.json();

      if (!response.ok) throw new Error(data.error || "Ошибка смены пароля");

      setSuccess("Пароль успешно изменен!");
      setNewPassword("");
    } catch (err) {
      setError(err.message);
      setSuccess(null);
    }
  };

  const handleDeleteUser = async () => {
    if (!selectedUser) {
      setError("Выберите пользователя");
      return;
    }
  
    try {
      const response = await fetch(`/api/delete-user/${selectedUser}`, {
        method: "DELETE", // Используем DELETE вместо POST
        headers: { "Content-Type": "application/json" }
      });
  
      const data = await response.json();
  
      if (!response.ok) throw new Error(data.error || "Ошибка удаления");
  
      setSuccess("Пользователь удален!");
      setSelectedUser(""); // Сбрасываем выбор
      fetchUsers();
    } catch (err) {
      setError(err.message);
      setSuccess(null);
    }
  };

  const roles = [
    { value: "user", label: "Отдел продаж" },
    { value: "service", label: "Сервис" },
    { value: "prefull", label: "Стоянка" },
    { value: "office-manager", label: "Отгрузка" },
    { value: "full", label: "Мастер приемщик" },
    { value: "admin", label: "Администратор" },
  ];
  
  if (role === null) {
    return <p>Загрузка...</p>; 
  }

  return (
    <div style={styles.container}>
      <div style={styles.link_div}>
        <Link  style={styles.button} to="/complect">Добавить комплектацию</Link>

      </div>
      
      <h2>Админ-панель</h2>
      <div>
      <DownloadReport />
        <RegisterForm onUserRegistered={fetchUsers} /> 
      </div>
      <div style={styles.container2}>
      {/* Список пользователей */}
      <table style={styles.table}>
        <thead>
          <tr>
            <th>Логин</th>
            <th>Роль</th>
            <th>Выбрать</th>
          </tr>
        </thead>
        <tbody>
          {users.length > 0 ? (
            users.map((user) => (
              <tr key={user.id}>
                <td>{user.login}</td>
                <td>
                  {
                    roles.find(r => r.value === user.role)?.label || user.role
                  }
                </td>
                <td>
                  <input
                    type="radio"
                    name="selectedUser"
                    value={user.id}
                    onChange={() => setSelectedUser(user.id)}
                  />
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="4">Нет пользователей</td>
            </tr>
          )}
        </tbody>
      </table>

      {/* Форма смены пароля */}
      <div style={styles.form}>
        <input
          type="password"
          placeholder="Введите новый пароль"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          style={styles.input}
        />
        <button onClick={handleChangePassword} style={styles.button_add_akk}>
          Сменить пароль
        </button>
        <button type="button" onClick={handleDeleteUser} style={styles.button_add_akk}>
          удалить Пользователя
        </button>
      </div>

      {error && <p style={styles.error}>{error}</p>}
      {success && <p style={styles.success}>{success}</p>}
    </div>
    </div>
  

  );
};

// Стили
const styles = {
  container: { maxWidth: "800px", margin: "auto", padding: "20px 0 0 0",textAlign: "center", marginTop: "40px" ,overflowY: "auto",height: "calc(100vh - 50px)"},
  container2: { maxWidth: "800px", padding: "20px", border: "1px solid gray",borderRadius: "9px", margin: "0 0 10px 0"},
  table: { width: "100%", borderCollapse: "collapse", marginBottom: "20px" },
  input: { padding: "8px", borderRadius: "5px", border: "1px solid #ccc", width: "250px"},
  button: {
    padding: "10px",
    marginTop: "10px",
    border: "none",
    borderRadius: "5px",
    background: "#007bff",
    color: "#fff",
    cursor: "pointer",
    width: "185px",
    textDecoration: "auto",
   
  },
  button_add_akk: {
    padding: "10px",
    marginTop: "10px",
    border: "none",
    borderRadius: "5px",
    background: "#007bff",
    color: "#fff",
    cursor: "pointer",
    width: "205px",
    textDecoration: "auto",
    
  },
  link_div: {display: "flex",    flexDirection: "column", alignItems: "center"},
  form: { display: "flex", flexDirection: "column", gap: "10px",    alignItems: "center" },
  error: { color: "red", fontWeight: "bold" },
  success: { color: "green", fontWeight: "bold" },
};

export default AdminPanel;
